module.exports = __webpack_public_path__ + "img/thumb_05.46567829.jpg";